import { u_ } from "@pressmedia/webappbase";

function addKeyPrefixToObject(obj, prefix) {
	if( !obj || typeof obj !== "object" || Array.isArray(obj) ) {
		throw new TypeError("addKeyPrefix() ... arguments[0] must be object.");
	}
	
	if( prefix && u_.isString(prefix) ) {
		const enableTypes = ["string", "number"];
		Object.keys(obj).forEach(k => {
			if(enableTypes.indexOf(typeof obj[k]) >= 0) {
				obj[prefix + k] = obj[k];
			}
			delete obj[k];
		});
	}
	
	return obj;
}

export default addKeyPrefixToObject;
